





































import { defineComponent, PropType, toRef } from 'vue';
import { EventRefined } from '@fullcalendar/core/internal';
import Icon from '../../../shared/components/Icon.vue';
import { useCalendarViewTimelineViewEvent } from '../../composables/calendar/useCalendarViewTimelineViewEvent';

export default defineComponent({
  name: 'CalendarViewTimelineViewEvent',
  components: { Icon },
  props: {
    eventModel: { type: Object as PropType<EventRefined>, required: true },
    isStart: { type: Boolean, default: true },
    isEnd: { type: Boolean, default: true },
  },
  setup(props) {
    return useCalendarViewTimelineViewEvent(toRef(props, 'eventModel'), toRef(props, 'isStart'), toRef(props, 'isEnd'));
  },
});
